<template>
  <div>
    <!-- Preloader Starts -->
    <!-- <div class="preloader">
      <div class="spinner"></div>
    </div> -->
    <!-- Preloader End -->

    <!-- Header Area Starts -->
    <header class="header-area single-page">
      <div class="header-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-2" style="position: relative;">
              <div class="logo-area">
                <a href="/">
                  <img src="static/assets/images/kunyu_logo.png" style="width:150px;height:auto;"/>
                </a>
              </div>
<!--              <div class="slogan">-->
<!--                <span>让数据产生价值</span><br>-->
<!--                <span>让安全智慧无忧</span>-->
<!--              </div>-->
            </div>
            <div class="col-lg-10">
              <div class="custom-navbar">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="main-menu main-menu-light">
                <ul>
                  <li v-for="(item, index) in menuList" :key="index" :class="{ mainmenuli: !(item.children.length>0) }" >
                    <a href="javascript:void(0)" @click="routerlinkClick(item,index)" style="font-size: 20px;" :style="getStyle(index)">{{ item.name }}</a>
                    <ul class="sub-menu" v-if="item.children.length > 0">
                      <li v-for="(childrenItem, index) in item.children" :key="index" class="mainmenuli">
                        <a href="javascript:void(0)" style="font-size: 18px; font-weight: normal;" @click="routerlinkClick(childrenItem)" >{{ childrenItem.name }}</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="conent_box">
      <router-view :list="list" :menuList="menuList"></router-view>
    </div>
    <!-- Header Area End -->
    <!-- Footer Area Starts -->
    <footer  class="footer-area section-padding">
      <div class="footer-widget">
        <div class="container">
          <div class="row">
            <div class="col-xl-3 col-lg-3">
              <div class="single-widget-home mb-5 mb-lg-0 zuoyou">
                <h3 class="mb-4">售前咨询热线:</h3>
                <h3 class="mb-4">+86-21-67631999</h3>
              </div>
            </div>
<!--            <div class="col-xl-2 col-lg-2">-->
<!--              <div class="single-widget-home mb-5 mb-lg-0 daohang">-->
<!--                <h3 class="mb-4">快速导航</h3>-->
<!--                <ul>-->
<!--                  <li class="mb-2"><a href="#">解决方案</a></li>-->
<!--                  <li class="mb-2"><a href="#">合作案例</a></li>-->
<!--                  <li class="mb-2"><a href="/about">关于我们</a></li>-->
<!--                  <li><a href="/jobSingle">招贤纳士</a></li>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
            <div class="col-xl-5 col-lg-6">
              <div class="single-widget-home mb-5 mb-lg-0 lianix">
                <h3 class="mb-4">联系我们</h3>
                <!-- <p class="mb-4">You can trust us. we only send promo offers, not a single.</p>
              <form action="#">
                <input type="email" placeholder="Your email here" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your email here'" required>
                <button type="submit" class="template-btn">subscribe now</button>
              </form> -->
                <ul>
                  <li class="mb-2"><span>上海坤瑀智能科技有限公司</span></li>
                  <li class="mb-2">
                    <span>地址：上海：崇明区兴奔路66号</span><br>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京：丰台区马家堡西路15号1区21层</span><br>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;天津：西青经济技术开发区兴华三支路5号E1座</span>
                  </li>
<!--                  <li class="mb-2"><span>邮箱：market@saveus.cn</span></li>-->
                  <li><span>电话：+86-21-67631999</span></li>
                </ul>
              </div>
            </div>
            <div class="col-xl-2 col-lg-2">
              <div class="single-widge-home chengxu">
                <h3 class="mb-4" >公众号</h3>
                <div class="feed " style="display: flex;" >
                  <ul>
                    <li>
                      <img src="static/assets/images/kunyu_qrcode.png"  alt="feed"/>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-lg-2">
              <div class="single-widge-home chengxu">
                <h3 class="mb-4" >移动端</h3>
                <div class="feed " style="display: flex;" >
                  <ul>
                    <li>
                      <img src="static/assets/images/kunyu_m_qrcode.png"  alt="feed"/>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="footer-copyright">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-6" style="text-align: center;font-size: 1.5vh;">
              <span>Copyright &copy;上海坤瑀智能科技有限公司</span>
            </div>
            <!-- <div class="col-lg-4 col-md-6">
            <div class="social-icons">
              <ul>
                <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                <li><a href="#"><i class="fa fa-dribbble"></i></a></li>
                <li><a href="#"><i class="fa fa-behance"></i></a></li>
              </ul>
            </div>
          </div> -->
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer Area End -->

  </div>
</template>
<script>
import request from "@/utils/request";
import { adds, us } from '@/api/index'
import axios from "axios";
export default {
  name: 'app',
  data() {
    return {
      status: false,
      menuList: [],
      currentIndex:0,
      list: {
        position1: [],
        position2: [],
        position3: [],
        position4: [],

      },
      psrmas:'www.kingunit.com'
    }
  },
  mounted() {
    this.getMenu();
  },
  methods: {
    async getMenu() {
      axios.get(`http://cms.saveus.cn/api/ttg/columns?domain=${this.psrmas}`).then(res=>{
        this.menuList = res.data.data;
        this.getus(this.menuList[0].id)
      })
    },
    getus(id) {
      axios.get('http://cms.saveus.cn/api/ttg/page?id='+id).then(
        res => {
          let list = res.data.data;
          for (let index = 0; index < list.length; index++) {
            if (list[index].position == 1) {
              this.list.position1.push(list[index])
            } else if (list[index].position == 2) {
              this.list.position2.push(list[index])
            } else if (list[index].position == 3) {
              this.list.position3.push(list[index])
            } else if (list[index].position == 4) {
              this.list.position4.push(list[index])
            }
          }
        }
      )
    },
    routerlinkClick(item, index) {
      if (item.children.length > 0) {
        return;
      }

      this.list.position1 = [];
      this.list.position2 = [];
      this.list.position3 = [];
      this.list.position4 = [];
      if (item.note === "article") {
        this.$router.push({
          path: "detail",
          query:{
            id:item.id,
            source: "article"
          }
        })
      } else {
        this.$router.push({
          path: item.note,
          query:{
            id:item.id
          }
        })
      }
      this.currentIndex = index;
      this.getus(item.id);
    },
    getStyle(index){
      if(this.currentIndex ===index){
        return {
          color: '#ff9902'
        }
      }
    }
  },
}
</script>
<style>
  @media (max-width: 765px) {
    .detail_brief img {
      width: 100%!important;
    }
    .el-carousel__container{
      height: 120vh !important;
    }
  }
  .detail_brief span {
    white-space: normal!important;
  }
  .el-carousel__arrow{
    display: none;
  }
</style>

<style scoped>
  .slogan{
    position: absolute;
    color: #fff;
    font-size: 24px;
    /*font-weight: bold;*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-top: 15px;
    letter-spacing: 2px;
  }
  .slogan span:last-child{
    display: inline-block;
    text-indent: 1em;
  }
.conent_box{
  min-height: 60vh;
}
._box{
  min-height: 100vh;
}
/* 最小 */
@media (min-width: 280px) and (max-width: 820px){
  .mb-5{
    margin-bottom: 1rem!important;
  }
  .zuoyou{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .zuoyou > h3{
    font-size: 2.5vh;
  }
  .daohang>ul{
    display: flex;
    flex-wrap: wrap;
    font-size: 2vh;
  }
  .daohang>h3{
    font-size: 2.5vh;

  }
  .lianix > h3{
        font-size: 2.5vh;
  }
  .lianix>ul > li{
    font-size: 2vh;
  }
  .daohang>ul>li{
    text-align: center;
    width: 50%;
  }
  .chengxu>h3{
    text-align: center;
    font-size: 3vh;

  }
   .chengxu>.feed{
    width: 20vh;
    height: 20vh;
    /* background: #fff; */
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
   }
   .chengxu>.feed>img{
    width: 100%;
    height: 100%;
   }
}
/* 最大 */
@media (min-width: 1200px){
    .daohang>h3{
    font-size: 2vh;

  }

    .zuoyou > h3{
    font-size: 2vh;
  }
  .lianix > h3{
        font-size: 2vh;
  }
    .chengxu>h3{
    text-align: center;
    font-size: 2vh;

  }
     .chengxu>.feed{
    width: 10vh;
    height: 10vh;
    background: #fff;
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
   }
}

</style>




// WEBPACK FOOTER //
// App.vue?615cfdc3